import $ from 'jquery';
import config from './util/config';

var tableStack = function tableStack(table) {
  var isAccordion = table.hasClass('table-accordion');
  var mobileHtml = $('');

  if (isAccordion) {
    mobileHtml = $('<div class="light-accordion-holder d-lg-none" data-ct-component="table-accordion"></div>');
  } else {
    mobileHtml = $('<table class="table table-row-stacker d-block d-lg-none"><tbody></tbody></table>');
  }

  var columnHeaders = table.find('thead tr').children().clone();

  for (var n = 0; n <= columnHeaders.length; n += 1) {
    if ($(columnHeaders[n]).attr('colspan')) {
      var count = $(columnHeaders[n]).attr('colspan');
      $(columnHeaders[n]).removeAttr('colspan');

      for (var x = 1; x < count; x += 1) {
        columnHeaders.splice(n + 1, 0, $(columnHeaders[n]));
      }
    }
  }

  var rows = table.find('tbody tr').clone();

  for (var i = 0; i < rows.length; i += 1) {
    var rowContent = $(rows[i]).children();

    for (var _n = 0; _n <= rowContent.length; _n += 1) {
      if ($(rowContent[_n]).attr('rowspan')) {
        var _count = $(rowContent[_n]).attr('rowspan');

        $(rowContent[_n]).removeAttr('rowspan');

        for (var _x = 1; _x < _count; _x += 1) {
          $(rowContent[_n]).clone().insertBefore($(rows[i + _x]).children()[_n]);
        }
      }
    }

    var columnText = '';

    for (var _n2 = 1; _n2 < rowContent.length; _n2 += 1) {
      columnText += "<p><strong>".concat($(columnHeaders[_n2]).html(), "</strong></p><p>").concat($(rowContent[_n2]).html(), "</p>");

      if (isAccordion && _n2 + 1 < rowContent.length) {
        columnText += '<hr>';
      }
    }

    if (isAccordion) {
      mobileHtml.append('<div class="individual-accordion row">' + '<a class="accordion-title subhead-4">' + '<svg class="control-arrow right" role="img">' + "<use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"".concat(config.svgPath, "component-sprite.svg#caret-right\"></use>") + '</svg>' + "<header>".concat($(rowContent[0]).html(), "</header>") + '</a>' + '<div class="collapse">' + "<div class=\"accordion-content\">".concat(columnText, "</div>") + '</div>' + '</div>');
    } else {
      mobileHtml.append('<tr>' + "<th>".concat($(rowContent[0]).html(), "</th>") + '</tr>' + '<tr>' + "<td>".concat(columnText, "</td>") + '</tr>');
    }
  }

  $(mobileHtml).insertAfter(table);
};

var columnStack = function columnStack(table) {
  var columns = table.find('th').length;
  var mobileHtml = '<div class="table-column-stacked-mobile"><div class="row no-gutters">';
  var header = [];
  var content = [];
  table.find('thead th').each(function (index, el) {
    header.push($(el).text());
  });
  table.find('tbody td').each(function (index, el) {
    content.push($(el).html());
  });

  for (var i = 0; i < columns; i += 1) {
    mobileHtml += "<div class=\"col-12\"><div class=\"table-header\">".concat(header[i], "</div><div class=\"table-content\">").concat(content[i], "</div></div>");
  }

  mobileHtml += '</div></div>';
  $(mobileHtml).insertAfter(table);
};

export default (function () {
  $('.table-column-stacked').each(function (index, el) {
    columnStack($(el));
  });
  $('.table-row-stacker').each(function (index, el) {
    tableStack($(el));
  });
});